import './index.scss'
import { Link } from 'react-router-dom'
import LogoS from '../../assets/images/pe.svg'
import { HashLink } from 'react-router-hash-link'
import { useState } from 'react'

import { GoHomeFill } from 'react-icons/go'
import {
  FaGithub,
  FaLinkedin,
  FaEnvelope,
  FaUser,
  FaFolderOpen,
} from 'react-icons/fa'

type SectionId = 'home' | 'about' | 'projects' | 'contact' | '#' | '' | 'hero'

const NAV_ITEMS: {
  id: SectionId
  hash: string
  label: string
  icon: React.ReactElement
}[] = [
  {
    id: 'home',
    hash: '#',
    label: 'HOME',
    icon: <GoHomeFill className="icon" />,
  },
  {
    id: 'about',
    hash: '#about',
    label: 'ABOUT',
    icon: <FaUser className="icon" />,
  },
  {
    id: 'projects',
    hash: '#projects',
    label: 'PROJECTS',
    icon: <FaFolderOpen className="icon" />,
  },
  {
    id: 'contact',
    hash: '#contact',
    label: 'CONTACT',
    icon: <FaEnvelope className="icon" />,
  },
]

const Sidebar = () => {
  const [activeSection, setActiveSection] = useState<SectionId>('home')

  // useEffect(() => {
  //   // Map each section id → the DOM element
  //   const sectionEls: { id: SectionId; el: Element }[] = [
  //     {
  //       id: 'home' as SectionId,
  //       el:
  //         document.getElementById('hero') ??
  //         document.querySelector('[id="#"]') ??
  //         document.body,
  //     },
  //     {
  //       id: 'about' as SectionId,
  //       el: document.getElementById('about') as Element,
  //     },
  //     {
  //       id: 'projects' as SectionId,
  //       el: document.getElementById('projects') as Element,
  //     },
  //     {
  //       id: 'contact' as SectionId,
  //       el: document.getElementById('contact') as Element,
  //     },
  //   ].filter((s) => Boolean(s.el))

  //   if (sectionEls.length === 0) return

  //   const observer = new IntersectionObserver(
  //     (entries) => {
  //       // Pick the entry that is most visible
  //       const visible = entries
  //         .filter((e) => e.isIntersecting)
  //         .sort((a, b) => b.intersectionRatio - a.intersectionRatio)

  //       if (visible.length > 0) {
  //         const id = visible[0].target.id as SectionId
  //         // hero section uses id="#" or "hero" — normalise to 'home'
  //         setActiveSection(
  //           id === 'hero' || id === '#' || id === ''
  //             ? 'home'
  //             : (id as SectionId)
  //         )
  //       }
  //     },
  //     {
  //       // Fire when at least 30% of the section is visible
  //       threshold: [0.1, 0.3, 0.5],
  //       rootMargin: '-10% 0px -10% 0px',
  //     }
  //   )

  //   sectionEls.forEach(({ el }) => observer.observe(el))
  //   return () => observer.disconnect()
  // }, [])

  return (
    <div className="nav-bar">
      {/* Desktop logo */}
      <Link className="logo" to="/">
        <img src={LogoS} alt="logo" />
        <div className="logo-subtitle">P e l u m i</div>
      </Link>

      {/* Nav links */}
      <nav>
        {NAV_ITEMS.map(({ id, hash, label, icon }) => (
          <HashLink
            key={id}
            smooth
            className={[
              `nav-link`,
              `nav-link--${id}`,
              activeSection === id ? 'active' : '',
            ]
              .filter(Boolean)
              .join(' ')}
            to={`/${hash}`}
            aria-label={label}
            onClick={() => {
              setActiveSection(id)
              if (window !== undefined) {
                window.umami?.track('nav_link_clicked', { hash })
              }
            }}
          >
            {icon}
            <span className="nav-link__label">{label}</span>
          </HashLink>
        ))}
      </nav>

      {/* Social links — hidden on mobile bottom bar */}
      <ul className="nav-social">
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            title="LinkedIn Profile"
            href="https://www.linkedin.com/in/pelumi-akinrele-800980169/"
            onClick={() => {
              if (window !== undefined) {
                window.umami?.track('nav_linkedin_clicked')
              }
            }}
          >
            <FaLinkedin className="icon" />
          </a>
        </li>
        <li>
          <a
            target="_blank"
            rel="noopener noreferrer"
            title="Github Profile"
            href="https://github.com/peldev"
            onClick={() => {
              if (window !== undefined) {
                window.umami?.track('contact_github_clicked')
              }
            }}
          >
            <FaGithub className="icon" />
          </a>
        </li>
      </ul>
    </div>
  )
}

export default Sidebar
